import React from 'react';
import { Grid } from '@mui/material';
import getBaseEditor, { CommandPanels } from '../../BaseEditor';

const editorRenderer = (getControl) => (
  <Grid container spacing={2}>
    <Grid item sm={12}>
      {getControl('name')}
    </Grid>
    <Grid item sm={6}>
      {getControl('category')}
    </Grid>
    <Grid item sm={6}>
      {getControl('definition')}
    </Grid>
  </Grid>
);

export default getBaseEditor(editorRenderer, '/api/catalog/landcategories/', CommandPanels.catCommandPanel);
